"use client";
import React, { useState } from "react";
import "./lifestyle.css";
import Link from "next/link";
import { red } from "@mui/material/colors";

const LifestylePop = ({
  backgroundImage,
  title,
  subtext,
  title2,
  subtext2,
  popUpContent,
  popUpContent1,
  logo1,
  logo2,
  logo3,
  button1,
  button2,
  contentAlign,
  popUpImage,
  butcol,
  but2transform,
}) => {
  const [activePopUp, setActivePopUp] = useState(null);

  const handleButtonClick = (which) => {
    setActivePopUp(which);
  };

  const closePopUp = () => {
    setActivePopUp(null);
  };

  const activePopUpContent =
    activePopUp === "button1"
      ? popUpContent1 || popUpContent
      : popUpContent;

  const alignment = contentAlign === "left" ? "flex-start" : "flex-end";

  // Custom function to render Content
  const renderContent = (content) => {
    // Check if content is an array
    if (Array.isArray(content)) {
      return content.map((item, index) => <div key={index}>{item}</div>);
    } else if (typeof content === "string") {
      // If content is a string, render it as HTML
      return <div dangerouslySetInnerHTML={{ __html: content }} />;
    } else {
      // Fallback for non-string and non-array content
      return <div>{content}</div>;
    }
  };

  return (
    <section className="section-bg" id={title}>
      <div
        className="lifestyle-cont"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          alignItems: alignment,
        }}
      >
        <div className="overlay"></div>
        <div className="content-cont">
          <h1>{title}</h1>
          <div>{renderContent(subtext)}</div>
          <h1>{title2}</h1>
          <div>{renderContent(subtext2)}</div>
          <div className="logos-cont">
            <div
              className={
                logo1.visibility ? "logo-cont visible" : "logo-cont hidden"
              }
            >
              <img src={logo1.src} alt={logo1.alt} />
            </div>
            <div
              className={
                logo2.visibility ? "logo-cont visible" : "logo-cont hidden"
              }
            >
              <img src={logo2.src} alt={logo2.alt} />
            </div>
            <div
              className={
                logo3.visibility ? "logo-cont visible" : "logo-cont hidden"
              }
            >
              <img src={logo3.src} alt={logo3.alt} />
            </div>
          </div>
          {button1.popup ? (
            <button style={{ backgroundColor: butcol }}
              className={button1.visibility ? "btn visible" : "btn hidden"}
              onClick={() => handleButtonClick("button1")}
            >
              {button1.text}
            </button>
          ) : (
            <Link href={button1.link}>
              <button style={{ backgroundColor: butcol }}
                className={button1.visibility ? "btn visible" : "btn hidden"}
              >
                {button1.text}
              </button>
            </Link>
          )}
          {button2.popup ? (
            <button style={{ textTransform: but2transform }}
              className={button2.visibility ? "btn visible" : "btn hidden"}
              onClick={() => handleButtonClick("button2")}
            >
              {button2.text}
            </button>
          ) : (
            <Link href={button2.link}>
              <button
                className={button2.visibility ? "btn visible" : "btn hidden"}
              >
                {button2.text}
              </button>
            </Link>
          )}
          <p className="uia">
            use in <span >App</span>
          </p>
        </div>
      </div>
      {activePopUp && (
        <div className="pop-up-overlay" onClick={closePopUp}>
          <div className="pop-up" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closePopUp}>
              X
            </button>
            <div className="pop-up-body">
              <img src={popUpImage} width="200px" alt="Pop-up" />
              {renderContent(activePopUpContent)}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default LifestylePop;
